import React, { PropTypes, Component } from 'react';
import Money from 'common/components/money';
import SignContract from 'common/containers/sign_contract';

export default class AwardModal extends Component {
  constructor(props) {
    super(props);

    this.fetch = this.fetch.bind(this);
  }

  fetch() {
    const { entryAward, entry, fetchICA } = this.props;
    fetchICA(entry.project, entry.author, entryAward.feature.value);
  }

  render() {
    const { showing, entry, entryAward } = this.props;

    if (!showing) {
      return null;
    }

    return (
      <SignContract {...this.props} onUncollapse={this.fetch}>
        <p>
          We're so happy you've found something you love! After you award, you'll sign the project
          contract and work with {entry.author_username} in a private wrap-up to complete the project.
        </p>
      </SignContract>
    );
  }
}

AwardModal.propTypes = {
  showing: PropTypes.bool,
  entryAward: PropTypes.object,
  entry: PropTypes.object,
  fetchICA: PropTypes.func
};



// WEBPACK FOOTER //
// ./entries/components/award_modal.jsx